export default {
  computed: {
    lowerEmail: {
      get() {
        return this.model.email;
      },
      set(value) {
        return this.model.email = value.toLowerCase();
      }
    }
  }
}
